/* eslint-disable import/no-default-export */
import Chance from 'chance';

import { baseLicenceCredential } from './BaseLicenceCredential';
import { createMonthYearPair } from './utils';

const chance = new Chance();

export default () => {
  const { first: issueDate, second: expiryDate } = createMonthYearPair(2000);

  return {
    name: {
      text: chance.pickone([
        "Australian Driver's Licence",
        'Responsible Service of Alcohol',
        'Working with Children Check',
        'Heavy Rigid Licence',
        'High Risk Work Licence',
      ]),
      ontologyId: chance.url(),
    },
    issuingOrganisation: chance.bool()
      ? chance.pickone([
          'Vicroads',
          'Victorian Commission for Gambling and Liquor Regulation',
        ])
      : null,
    issueDate: chance.bool() ? issueDate : null,
    expiryDate: chance.bool() ? expiryDate : null,
    noExpiryDate: chance.bool(),
    description: chance.bool()
      ? chance.pickone([
          'Acquired during previous employment.',
          'This licence means I can do X, Y and Z.',
        ])
      : null,
    status:
      chance.d4() === 1
        ? null
        : chance.pickone(['New', 'ExpiresSoon', 'Expired']),
    formattedDate: chance.bool({ likelihood: 90 })
      ? chance.pickone([
          'Valid until Jan 2030',
          'Expired Dec 2019 (Only visible to you)',
          'Jan 2019 - Jan 2030',
          'Current',
          'Issued on Jan 2019',
        ])
      : null,
    credential: chance.bool() ? baseLicenceCredential : null,
  };
};
